angular.module('impactx.deliverycomplaint').controller('SimpleComplaintAskSendToSupplierDialogCtrl', SimpleComplaintAskSendToSupplierDialogCtrl);

SimpleComplaintAskSendToSupplierDialogCtrl.$inject = ['$scope', '$mdDialog', 'trns', 'complaintHeaders'];

function SimpleComplaintAskSendToSupplierDialogCtrl($scope, $mdDialog, trns, complaintHeaders)
{
    $scope.trns = trns;
    $scope.complaintHeaders = complaintHeaders;

    var ctrl = this;

    angular.forEach($scope.complaintHeaders, function (header) {
        if (header.allowAskSendToSupplier) {
            angular.forEach(header.selectedItems, function (item) {
                const treatment = item.treatment.setId;
                if (treatment === 208) {
                    item.sendItemToSupplier.value = false;
                }
            });
        }
    });
    
    ctrl.accept = function(){
        $mdDialog.hide($scope.complaintHeaders);
    };
    
    ctrl.closeDialog = function(event){
        $mdDialog.hide();
    };

    ctrl.getComplainedAmount = function (item) {
        if (!item.complainedAmount.selected || !item.complainedAmount.selected.value) {
            return item.deliveredAmount.value;
        } else if (item.complainedAmount.selected.id === 4) {
            return item.complainedAmount.selected.value + ": " + item.complainedAmountFree.value;
        } else {
            return item.complainedAmount.selected.value;
        }
    };

    ctrl.getTreatment = function (item) {
        var value;
        angular.forEach(item.treatment.entries, function (entry) {
            if (item.treatment.setId === entry.value) {
                value = entry.label;
            }
        });
        return value;
    };

    // Sync function here is the same as the base dialog but only for sendMail
    ctrl.syncItems = function ($event, item) {
        if (item.dnhId) {
            angular.forEach($scope.complaintHeaders, function (header) {
                if (header.dnhId && item.dnhId !== header.dnhId) {
                    // check if the current settings include or depend on other item's amounts (Return+AllDelivered, Return+Ordered, or any "open Amount")
                    // then sync the items
                    if (item.treatment.setId === 201 || ((item.treatment.setId === 207 || item.treatment.setId === 208)
                        && item.complainedAmount.selected && item.complainedAmount.selected.id !== 2)) {
                        // only selected items to check
                        angular.forEach(header.selectedItems, function (entry) {
                            // if there is an entry for a different dni but the same poi
                            if (item.dniId !== entry.dniId && item.poiId === entry.poiId) {
                                // sync the found entry to match the current, no cache needed
                                entry.sendItemToSupplier = item.sendItemToSupplier;
                            }
                        });
                    }
                }
            });
        }
    };
}
